import React from "react";
import FacilitiesCard from "./FacilitiesCard";
import { facilitiesData } from "./facilitiesData";
import { AnimatePresence } from "motion/react";
import PageHeading from "../../../templates/PageHeading";
import PageTitleCard from "../../templates/PageTitleCard";
import { useQuery } from "react-query";
import axios from "axios";
import { BASEURL } from "../../../../utils/BaseUrl";
import FixedFooter from "../../templates/FixedFooter";
import Footer from "../../../components/footer/Footer";
import BackHome from "../../../templates/BackHome";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import CurrentPath from "../../../templates/CurrentPath";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const FacilitiesBox = () => {
  const { data, isLoading } = useQuery({
    queryKey: "getallfacilities",
    queryFn: () =>
      axios.get(`${BASEURL}facilities`).then((res) => {
        return res?.data;
      }),
  });
  return (
    <div>
      <PageTitleCard>
        <PageHeading>Facilities</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>Facilities</CurrentPath>
        </div>
      </PageTitleCard>
      <FixedFooter>
        <div className="py-8 mx-auto container max-sm:px-8">
          <SubHeadingText>Our Facilities</SubHeadingText>
          <div className="grid lg:grid-cols-2 md:grid-cols-1 sm:grid-cols-1 max-sm:grid-cols-1 gap-10 container mx-auto py-8 md:px-4 sm:px-4 max-sm:px-4">
            {isLoading
              ? Array.from({ length: 6 }).map((_, i) => (
                  <Skeleton className="w-full h-[400px]" key={i} />
                ))
              : data?.map((val, i) => {
                  return (
                    <FacilitiesCard
                      key={i}
                      title={val.machine_type}
                      size={val.size}
                      index={i}
                      url={val.image_url}
                    />
                  );
                })}
          </div>
        </div>
      </FixedFooter>
    </div>
  );
};

export default FacilitiesBox;
